import { ComponentType } from 'react';
import FlowOfGame from './FlowOfGame';
import MakingMoves from './MakingMoves';
import Combat from './Combat';
import Stress from './Stress';
import Attacking from './Attacking';
import MapsRangeMovement from './MapsRangeMovement';
import Conditions from './Conditions';
import Downtime from './Downtime';
import Death from './Death';
import LevelingUp from './LevelingUp';
import Multiclassing from './Multiclassing';
import AdditionalRules from './AdditionalRules';
import Equipment from './Equipment';
import Weapons from './Weapons';
import CombatWheelchair from './CombatWheelchair';
import Armor from './Armor';
import Traits from './Traits';
import Gold from './Gold';

export const mechanicsContent: Record<string, ComponentType> = {
  'FLOW OF THE GAME': FlowOfGame,
  'MAKING MOVES & TAKING ACTION': MakingMoves,
  'TRAITS': Traits,
  'COMBAT': Combat,
  'STRESS': Stress,
  'ATTACKING': Attacking,
  'MAPS, RANGE, AND MOVEMENT': MapsRangeMovement,
  'CONDITIONS': Conditions,
  'DOWNTIME': Downtime,
  'DEATH': Death,
  'LEVELING UP': LevelingUp,
  'MULTICLASSING': Multiclassing,
  'EQUIPMENT': Equipment,
  'GOLD': Gold,
  'WEAPONS': Weapons,
  'ARMOR': Armor,
  'COMBAT WHEELCHAIR': CombatWheelchair,
  'ADDITIONAL RULES': AdditionalRules,
};
